import { useEffect } from "react";

export function useHeadMeta({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  useEffect(() => {
    setPageTitle(title);
  }, [title]);

  useEffect(() => {
    setPageDescription(description);
  }, [description]);
}

function setPageTitle(title: string) {
  document.title = title;

  const metaOgElement = document.querySelector('meta[property="og:title"]');
  if (metaOgElement) {
    metaOgElement.setAttribute("content", title);
  }

  const metaTwitterElement = document.querySelector(
    'meta[name="twitter:title"]',
  );
  if (metaTwitterElement) {
    metaTwitterElement.setAttribute("content", title);
  }
}

function setPageDescription(description: string) {
  const metaDesc = document.querySelector('meta[name="description"]');
  if (metaDesc) {
    metaDesc.setAttribute("content", description);
  }

  const metaOgDesc = document.querySelector('meta[property="og:description"]');
  if (metaOgDesc) {
    metaOgDesc.setAttribute("content", description);
  }

  const metaTwitterDesc = document.querySelector(
    'meta[name="twitter:description"]',
  );
  if (metaTwitterDesc) {
    metaTwitterDesc.setAttribute("content", description);
  }
}
